const nn = {
  common: {
    wallet: "lommebok",
    playPage: "spill",
    minTop: "minste beløp er $10",
    maxTop: "maksimalt beløp er $500",
    website: "nettsted",
    signOut: "logg ut",
    hidden: "skjult",
    victory: "seier",
    wentWrong: "noe gikk galt, omdirigerer",
    stakeLabel: "innsats",
    howDoes: "hvordan fungerer dette?",
    continue: "Fortsett",
    continueWithGoogle: "Fortsett med Google",
    continueWithApple: "Fortsett med Apple",
    termsOfService: "brukervilkår",
    privacyPolicy: "personvernpolicy",
    termsOfServiceFooter: "brukervilkår",
    privacyPolicyFooter: "personvernpolicy",
    verificationCode: "bekreftelseskode",
    verify: "bekrefte",
    account: "konto",
    error: "en feil oppsto\n",
    checkBackLater: "sjekk tilbake senere",
    looking: "ser...",
    yes: "ja",
    no: "nei",
    pleaseSelect: "Vennligst velg\n",
    disclaimer: "ved å fortsette aksepterer du våre\n",
    and: "og",
  },
  endOfGame: {
    wonByCheckmate: "vant ved sjakk matt",
    lostOnTime: "tapt på tid",
    resigns: "resignerer",
    gameDrawnByAgreement: "spillet endte i remis ved avtale",
    abandonedTheGame: "forlot spillet",
    gameAborted: "spillet ble avbrutt",
    gameDrawnByStalemate: "spillet endte i remis ved stillingsremis",
    gameDrawnByFiftyMoveRule: "spillet endte i remis ved femtitrekksregelen",
    gameDrawnByInsufficientMaterial: "spillet endte i remis på grunn av utilstrekkelig materiale",
    gameDrawnByThreefoldRepetition: "spillet endte i remis ved trefoldig repetisjon",
    draw: "remis",
    victory: "seier",
    defeat: "nederlag",
    aborted: "avbrutt",
    white: "hvit",
    black: "svart",
    inspectBoard: "vis brett",
    returnToEndOfGameModal: "fortsett",
  },
  byPhone:{
    continueOnPhone: "fortsett på\ntelefon",
    or: "eller",
    continueOnWeb: "fortsett i\nnettleseren din",
    disclaimer: "passer hvis du har et bilde av IDen din på disken"
  },
  signUp: {
    email: "e-post",
    username: "brukernavn",
    usernameInvalid: "ugyldig brukernavn",
    emailInvalid: "ugyldig e-post",
    login: "logg inn",
    continueWithPhone: "fortsett med telefonnummer",
    tickBoxes: "la oss krysse av noen\nbokser",
    confirm: "Jeg bekrefter at\n",
    resideIn: "Jeg bor i\n",
    notPEP: "Jeg er ikke en politisk eksponert person (PEP), et familiemedlem eller en kjent bekjent av en PEP\n",
    purpose: "Formålet og karakteren av forholdet mitt med Gambit er utelukkende å bruke tjenesten for underholdning\n",
    soleBenefit: "Jeg vil bruke tjenesten utelukkende for min egen fordel, og det er ingen andre reelle rettighetshavere\n",
  },
  identity: {
    beingVerified: "identitet\nblir verifisert",
    verified: "verifisert\n",
    failed: "verifisering\nmislyktes",
  },
  payment: {
    failed: "betaling mislyktes.\nprøv igjen",
    successful: "betaling\nvellykket!",
    toppedUp: "du er\ntoppet opp!",
    topUp: "fyll opp\n",
    payWith: "betal med...\n",
  },
  gameplay: {
    play: "spill\n",
    challenge: "utfordrer deg til en",
    gameWorth: "spill verdt\n",
    whatsYourNumber: "hva er ditt\nnummer?",
    receiveCode: "du vil motta en bekreftelses\ncode om kort tid",
    matchedOpponent: "Du vil bli matchet mot en motstander med en lignende rating.",
    stake: {
      total: "Den totale innsatsen vil være beløpet som er valgt nedenfor.",
      contribution: "Du vil bidra med omtrent halvparten av det beløpet.",
      weakerOpponent: "Hvis du blir matchet mot en svakere motstander, vil du betale en større del av innsatsen.",
      strongerOpponent: "Hvis du blir matchet mot en sterkere motstander, vil du betale en mindre del av innsatsen.",
    },
    supportInfo: "Besøk vår support for mer informasjon.\n",
    continueBrowser: "fortsett i\nnettleseren din",
    continuePhone: "fortsett på\ntelefon",
    getStarted: "la oss komme\ni gang",
    sentText: "vi har sendt deg\ntekst",
    enterReceivedCode: "skriv inn den mottatte\nbekreftelseskoden",
    wrongCode: "feil kode, prøv igjen\n",
    secPerMove: "sek/trekk",
    resign: {
      prompt: "er du sikker på at du vil gi opp?",
    },
    draw: {
      offer: "godta remistilbud?",
    },
    rating: "rating\n",
    balance: "balanse\n",
    rematch: "omkamp\n",
    newOpponent: "ny motstander\n",
    home: "hjem\n",
    rematchOffer: "din motstander tilbyr en omkamp. godta?",
    leaveGame: "Du spiller for øyeblikket et spill. Er du sikker på at du vil forlate?",
    room: "rom:\n",
    gameTypes: {
      bullet: {
        title: "kule\n",
        description: "Adrenalin sjakk. Du og motstanderen din får bare 1 minutt hver til å vinne spillet.",
      },
      blitz: {
        title: "blitz\n",
        description: "Du og motstanderen din får 3 minutter hver til å vinne spillet.",
      },
    },
    stakes: {
      unlockNext: "spill {amount} flere spill for å låse opp den neste innsatsen",
      allUnlocked: "du har låst opp alle innsatsene",
    },
    withdraw: "uttak\n",
  },
  puzzle: {
    begin: "begynne",
    next: "neste",
    unavailableInYourRegion: "utilgjengelig",
    puzzle: "puslespill",
    whiteToPlay: "hvit ved draget",
    blackToPlay: "svart ved draget",
    time: "tid",
    solution: "løsning",
    somethingWentWrong: "noe gikk galt",
    rating: "vurdering",
    credits: "kreditter",
    puzzleFailed: "tap",
    puzzleSolved: "seier",
    correct: "korrekt løsning",
    incorrect: "feil løsning",
    youRanOutOfTime: "du har gått tom for tid",
    puzzleDescription: "Du har 10 sekunder + 2 sekunder/drag til å løse et puslespill.",
    creditsLeft: "tilgjengelige kreditter",
    refillIn: "påfylling om",
    lastPuzzle: "Dette er ditt siste puslespill, sjekk tilbake senere for mer.",
    outOfCredits: "Du har gått tom for kreditter, sjekk tilbake senere.",
    locationPrompt: "Vi trenger posisjonen din for å fortsette. Hvis den er blokkert, vennligst aktiver den igjen:",
    locationInstructions: "Klikk på ikonet i adresselinjen, velg 'Alltid tillat' og oppdater siden",
    creditsError: "Feil ved lasting av kreditter",
    moves: "Trekk:",
  },
};

export {nn};